__turbopack_context__.v({
  "body": "infrastructure-audits-module__5CHVSq__body",
  "capabilities": "infrastructure-audits-module__5CHVSq__capabilities",
  "capability": "infrastructure-audits-module__5CHVSq__capability",
  "checks": "infrastructure-audits-module__5CHVSq__checks",
  "clientLogo": "infrastructure-audits-module__5CHVSq__clientLogo",
  "clientLogos": "infrastructure-audits-module__5CHVSq__clientLogos",
  "clients": "infrastructure-audits-module__5CHVSq__clients",
  "closing": "infrastructure-audits-module__5CHVSq__closing",
  "closingCta": "infrastructure-audits-module__5CHVSq__closingCta",
  "closingInner": "infrastructure-audits-module__5CHVSq__closingInner",
  "closingText": "infrastructure-audits-module__5CHVSq__closingText",
  "collective": "infrastructure-audits-module__5CHVSq__collective",
  "column": "infrastructure-audits-module__5CHVSq__column",
  "contribution": "infrastructure-audits-module__5CHVSq__contribution",
  "cta": "infrastructure-audits-module__5CHVSq__cta",
  "ctaImage": "infrastructure-audits-module__5CHVSq__ctaImage",
  "hero": "infrastructure-audits-module__5CHVSq__hero",
  "heroCta": "infrastructure-audits-module__5CHVSq__heroCta",
  "heroInner": "infrastructure-audits-module__5CHVSq__heroInner",
  "heroLead": "infrastructure-audits-module__5CHVSq__heroLead",
  "heroTitle": "infrastructure-audits-module__5CHVSq__heroTitle",
  "highlight": "infrastructure-audits-module__5CHVSq__highlight",
  "highlightIcon": "infrastructure-audits-module__5CHVSq__highlightIcon",
  "highlightLabel": "infrastructure-audits-module__5CHVSq__highlightLabel",
  "highlightStat": "infrastructure-audits-module__5CHVSq__highlightStat",
  "highlightStatLink": "infrastructure-audits-module__5CHVSq__highlightStatLink",
  "highlights": "infrastructure-audits-module__5CHVSq__highlights",
  "highlightsWrapper": "infrastructure-audits-module__5CHVSq__highlightsWrapper",
  "kiln": "infrastructure-audits-module__5CHVSq__kiln",
  "republic": "infrastructure-audits-module__5CHVSq__republic",
  "rockx": "infrastructure-audits-module__5CHVSq__rockx",
  "rule": "infrastructure-audits-module__5CHVSq__rule",
  "sectionHeading": "infrastructure-audits-module__5CHVSq__sectionHeading",
  "valueProp": "infrastructure-audits-module__5CHVSq__valueProp",
});
